import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';
import { formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/util';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { CheckIcon, DeleteWhiteIcon, MasterIcon, VisaIcon } from '../../components/icons';

const drawerWidth = 520;

const styles = theme => ({
    method_container: {
        padding: theme.spacing(4, 0, 0, 0)
    },
    method_pre: {
        padding: theme.spacing(0, 2, 0, 0)
    },
    method: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        height: theme.spacing(12),
        padding: theme.spacing(1, 4, 1, 4),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        }
    },
    button_add: {
        marginTop: theme.spacing(10)
    },
    bg_icon: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    }
});

function CardsView(props) {
    const { classes, t, cards, showLoading, onClickDetail } = props;
    return (
        <DrawerCustom
            open={props.open}
            onClose={props.onClose}
            title={t('cards')}
            children={
                <Grid item>
                    <Grid item container justify='center' alignItems='center'>
                        {showLoading && <CustomizedCircularProgress />}
                    </Grid>
                    {cards && <Grid xs={12} item>
                        <Grid xs={12} item className={classes.item_list}>
                            {cards.map((item, index) => (
                                <Grid item xs={12} key={index}>
                                    <CardItem
                                        classes={classes}
                                        key={index}
                                        item={item}
                                        onClickDetail={onClickDetail}
                                    />
                                </Grid>
                            ))
                            }
                        </Grid>
                    </Grid>}
                </Grid>
            } />
    );
}

function CardItem(props) {
    const { classes, item } = props;
    let card_holder_name = item.card && item.card.card_holder_details && item.card.card_holder_details.card_holder_name ? item.card.card_holder_details.card_holder_name : ""
    return (
        <Grid xs={12} item container className={classes.method_container}>
            <Grid item xs={12} className={classes.method} container alignItems='center' onClick={() => props.onClickDetail(item)}>
                <Grid xs={2} item container justify='flex-start'>
                    {item.brand === 'master' ? <MasterIcon /> : <VisaIcon />}
                </Grid>
                <Grid xs={8} item>
                    <CustomTypo mg_left_sm variant='body1'>{item && item.card && item.card.last4 ? "**** **** **** " + item.card.last4 : ""}</CustomTypo>
                </Grid>
                {item.is_recurring && <Grid xs={2} item container justify='flex-end' >
                    <CheckIcon />
                </Grid>}
            </Grid>
        </Grid>
    )
}

export default withStyles(styles)(withTranslation()(CardsView));